
import userSignin from '~/components/login/userSigin.vue' // 登录框左侧
import userDealer from '~/components/login/userDealer.vue'
import userRegister from '~/components/login/userRegister.vue' // 注册
import userReset from '~/components/login/userReset.vue' // 重置
import userQrcode from '~/components/login/userQrcode.vue' // 二维码
import userMpopup from '~/components/login/userMpopup.vue' // m端登录弹框
import Newjoin from '~/components/service/Newjoin.vue'

export default {
  components: {
    'user-sigin': userSignin, // 登录框
    'user-reset': userReset, // 验证码
    'user-register': userRegister, // 注册
    'user-qrcode': userQrcode, // 二维码
    'user-dealer': userDealer, // 交易商
    'user-mpopup': userMpopup, // 交易商
    Newjoin
  },
  layout: 'common',
  props: {
    closebtn: {
      // 关闭是否隐藏
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      loginCode: this.$route.query.type == 'register' ? 2 : 1, // 1.手机号+验证码 2.注册 3.重置
      currentAddress: this.$route.path.substring(this.$route.path.lastIndexOf('/') + 1), // 当前页面地址
      phone: '', // 输入的手机号
      verifCode: '', // 验证码
      requestId: '', // 登录极验id
      disbl: this.$route.query.type == 'register', // m端登录是否展示
      isTo: false // 是否跳转用户中心
    }
  },
  computed: {
    title() {
      if (this.loginCode == 2) {
        return this.$v('注册')
      } else {
        return this.$v('验证码')
      }
    },
    voiceTitle() {
      if (this.loginCode == 2) {
        return this.$v('注册')
      } else {
        return this.$v('语言验证')
      }
    }
  },
  watch: {
    // close (newValue) { // 搜索后的列表
    //   this.loginCode = 1
    // },
    '$store.state.loginShow'(newVal) {
      const dodyWidth = document.documentElement.clientWidth
      if (!newVal) document.querySelector('html').style.overflowY = 'unset'
      else if (dodyWidth < 799) document.querySelector('html').style.overflowY = 'hidden'
    }
  },
  mounted() {
    // setTimeout(() => {
    //   if (!this.isTo) {
    //     this.tologin()
    //   }
    // }, 500)
  },
  methods: {
    openlog(i) {
      console.log('i，弹框', i)
      this.isTo = i
      setTimeout(() => {
        if (!this.isTo) {
          this.tologin()
        }
      }, 500)
    },
    tologin() {
      this.close()
      if (this.$store.state.path.includes('login.html')) {
        // setTimeout(() => {
        if (process.client) location.href = `https://www.${this.$store.state.newhost}.${this.getSuffix(this.$store.state)}/${this.$store.state.LanguageCode}/usercenter/index.html`
        // }, 200)
      }
    },
    closedialog() {
      console.log('触发关闭')
      console.log('$store.state.loginShow', this.$store.state.loginShow)
      // this.close()
      //
    },
    awaitfn() {
      console.log('认证认领')
    },
    succeedfn() {
      console.log('成功')
    },
    errorfn() {
      console.log('失败')
    },
    popjoinflow() {
      console.log('加入')
      console.log('注册流程')
      const postdata = {
        op_type: 'register',
        url: '',
        parm: ''
      }
      window.parent && window.parent.postMessage(postdata, '*')
      this.loginCode = 4
      if (this.$refs.Joinflow) this.$refs.Joinflow.open({}) // 加入/认领流程
    },
    close() {
      if (this.$store.state.userlogin2) {
        const postdata = {
          op_type: 'close',
          url: '',
          parm: ''
        }
        window.parent && window.parent.postMessage(postdata, '*')
      } else {
        this.$store.commit('loginClose', false)
        this.loginCode = 1 // 切换为账号/手机登录
        this.phone = this.verifCode = this.requestId = ''
      }
      this.disbl = false // m端默认展示,根据页面大小使用媒体判断pc是否出现
      // this.$nextTick(() => {
      //   document.querySelector('.wiki-head').style.display = 'block'
      // })
    },
    loginSwitch(i) {
      // 切换状态
      this.loginCode = i
    },
    loginMswitch(i) {
      // m切换状态
      this.disbl = true
      this.loginCode = i
    },
    cellphoneNumber(i) {
      // 手机号
      this.phone = i
      // console.log('phone: ', this.phone)
    },
    verCode(code) {
      // 验证码
      this.verifCode = code
    },
    getRequestId(id) {
      // 登录未注册传进来的id
      this.requestId = id
    }
  }
}
